<template>
  <v-flex>
    <router-view></router-view>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {},

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
